import React from 'react';
import filterPropsEvents from '../reactUtils/filterPropsEvents';
import AnalyticsManager from '../../classes/AnalyticsManager';

export default function MenuItem(props: {
	label?: React.ReactNode,
	tooltip?: string,
	className?: string,
	id?: string,
	"data-name"?: string,
	disabled?: boolean,
	iconRenderer?: React.ReactNode,
	content?: React.ReactNode,
	shortcut?: string,
	endIconRenderer?: React.ReactNode,
	onClick?: (e: any) => void,
	category?: string,
})
{
	return (
		<table className={[
			"menuItemRoot",
			(props.className ? props.className : ""),
		].join(' ')}
		id={props.id ?? ""}
		data-name={props["data-name"] ?? "menu-item-" + props.label}
		data-enabled={props.disabled ? "false" : "true"}
		{...filterPropsEvents(props)}
		onClick={(e) => 
		{
			if(props.onClick && typeof props.label === "string")
			{
				AnalyticsManager.managedClick(props.label, "Menu");
				props.onClick(e);
			}
		}}
		data-tooltip={props.tooltip}
		>
			<tbody>
				<tr>
					<td className={"menuItemIcon"}>{props.iconRenderer}</td>
					{
						!props.label ? null :
							<td className={"menuItemLabel"}>{props.label}</td>
					}
					{
						!props.content ? null :
							<td className={"menuItemContent"}>
								{props.content}
							</td>
					}
					<td>
						<div className={"endMenuItemContainer"}>
							{
								!props.shortcut ? null :
									<div className={"menuItemShortcut"}>{props.shortcut}</div>
							}
							{props.endIconRenderer}
						</div>
					</td>
				</tr>
			</tbody>
		</table>
	)
}